import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getGenMaster } from '../../../../../Store/Store/GenralMaster/GenMaster';
import { getProject } from '../../../../../Store/Store/Project/Project';
import { getItem } from '../../../../../Store/Store/Item/Item';
import { ViewOthIssItems } from '../../../../../Store/prosafe/proTransaction/OtherIssue/ViewOthIssItems';
import toast from 'react-hot-toast';
import Footer from '../../../Include/Footer';
import Breadcrumb from '../../../../../Components/Breadcrumb/Breadcrumb';
import Header from '../../../Include/Header';
import Sidebar from '../../../Include/Sidebar';
import OtherIssFields from './components/OtherIssFields';
import OtherIssItems from './components/OtherIssItems';
import { V_URL } from '../../../../../BaseUrl';
import axios from 'axios';

const ManageOtherIss = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state: data } = useLocation();
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState({});
  const [form, setForm] = useState({
    trans_date: moment(Date.now()).format("YYYY-MM-DD"),
    project_id: "",
    manual_pro_no: "",
    master_id: "",
  });
  const [itemsArr, setItemsArr] = useState([]);

  useEffect(() => {
    dispatch(getGenMaster({ tag_id: 15 }));
    dispatch(getProject());
    dispatch(getItem({ is_main: true }));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (error[name]) {
      setError(prev => {
        const newError = { ...prev };
        delete newError[name];
        return newError;
      });
    }
  }

  const itemData = useSelector((state) => state?.ViewOthIssItems?.user?.data);
  useEffect(() => {
    if (data?._id) {
      dispatch(ViewOthIssItems({ formData: { id: data?._id } }));
      setForm({
        trans_date: data?.trans_date ? moment(data?.trans_date).format("YYYY-MM-DD") : "",
        project_id: data?.project_data?._id,
        manual_pro_no: data?.manual_pro_no,
        master_id: data?.other_issue_by?._id,
      });
    } else {
      handleReset();
    }
  }, [data]);

  useEffect(() => {
    if (data?._id) {
      if (itemData?.items_details?.length > 0) {
        setItemsArr(itemData.items_details);
      } else {
        setItemsArr([]);
      }
    } else {
      setItemsArr([]);
    }
  }, [itemData, data]);

  const validateItems = () => {
    if (!itemsArr || itemsArr.length === 0) {
      toast.error("At least one item is required");
      return false;
    }
    return true;
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;
    const checkRequired = (field, message) => {
      if (!form[field]) {
        newErrors[field] = message;
        isValid = false;
      }
    };
    if (!form.trans_date) {
      newErrors.trans_date = "Date is required";
      isValid = false;
    } else {
      const selectedDate = new Date(form.trans_date);
      const currentDate = new Date();
      if (selectedDate > currentDate) {
        newErrors.trans_date = "Date cannot be in the future";
        isValid = false;
      }
    }
    checkRequired('project_id', 'Project is required');
    checkRequired('master_id', 'Received By is required');
    setError(newErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (!validateForm()) {
      return;
    }
    if (!validateItems()) {
      return;
    }
  
    setDisable(true);
    const myurl = `${V_URL}/prosafe/pro-add-other-iss`;
    const formData = new URLSearchParams();
    formData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
    formData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));
    formData.append('tag_number', 15);
    formData.append('trans_date', form.trans_date);
    formData.append('project_id', form.project_id);
    formData.append('manual_pro_no', form.manual_pro_no);
    formData.append('master_id', form.master_id);
    formData.append("items_details", JSON.stringify(itemsArr));
    axios({
      method: "post",
      url: myurl,
      data: formData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    }).then((response) => {
      if (response.data.success === true) {
        toast.success(response?.data?.message);
        navigate("/main-store/user/other-issue-management");
      } else {
        toast.error(response?.data?.message);
      }
    }).catch((error) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }).finally(() => {
      setDisable(false);
    });
  }

  const handleUpdate = (e) => {
    if (!validateForm()) {
      return;
    }

    if (!validateItems()) {
      return;
    }

    setDisable(true);
    const myurl = `${V_URL}/prosafe/pro-update-other-iss`;
    const formData = new URLSearchParams();
    formData.append("id", data?._id);
    formData.append("trans_date", form.trans_date);
    formData.append('project_id', form.project_id);
    formData.append('manual_pro_no', form.manual_pro_no);
    formData.append("master_id", form.master_id);
    axios({
      method: "put",
      url: myurl,
      data: formData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    }).then((response) => {
      if (response.data.success === true) {
        toast.success(response?.data?.message);
        navigate("/main-store/user/other-issue-management");
      } else {
        toast.error(response?.data?.message);
      }
    }).catch((error) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }).finally(() => {
      setDisable(false);
    });
  }

  const handleReset = () => {
    setForm({
      trans_date: moment(Date.now()).format("YYYY-MM-DD"),
      project_id: "",
      master_id: "",
    });
    setItemsArr([]);
    setError({})
  }

  const breadcrumbItems = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    { label: "Other Issue", link: "/main-store/user/other-issue-management" },
    { label: data?._id ? "Edit" : "Add" + " Other Issue", active: true },
  ];

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>{data?._id ? 'Edit' : 'Add'} Other Issue Details</h4>
                      </div>
                    </div>

                    <OtherIssFields
                      handleChange={handleChange}
                      form={form}
                      error={error}
                      data={data}
                    />

                  </form>
                </div>
              </div>
            </div>
          </div>

          <OtherIssItems
            itemsArr={itemsArr}
            setItemsArr={setItemsArr}
            data={data}
            form={form}
          />

          <div className='row'>
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12 text-end">
                    <div className="doctor-submit text-end">
                      <button type="button"
                        className="btn btn-primary submit-form me-2"
                        onClick={data?._id ? handleUpdate : handleSubmit}
                        disabled={disable && !data?._id}>
                        {disable ? "Processing..." : (data?._id ? 'Update' : "Submit")}
                      </button>
                      <button type="button"
                        className="btn btn-primary cancel-form"
                        onClick={handleReset}>
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <Footer />
      </div>
    </div>
  )
}

export default ManageOtherIss